module.exports = __webpack_public_path__ + "img/filter_list.3feadbd9.svg";